<template>
  <div class="receipts">
    <div v-for="bet in betsCompleted" :key="bet.id" class="receiptContainer">
      <div class="receiptContainer">
        <div class="logoContainer">
          <img :src="imageUrl" alt="venue logo" class="logoSet"/>
          <p style="margin: 0 !important;">{{bet.ticket_id}}</p>
        </div>
        <div class="tableContainer">
          <h3 class="raceHeader" v-if="bet.refund_owing">* CUSTOMER COPY *</h3>
          <h3 class="raceHeader">{{bet.trackName}} - Race {{bet.trackNumber}}</h3>
          <h4 class="raceHeader">{{bet.raceName}}</h4>
          <h4 class="raceHeader">Start: {{formatStartTime(moment(bet.startTime))}}</h4>
          <div class="lineBreak"></div>
          <table class="tableContainer">
            <thead class="tableHeader">
            <th>Cost</th>
            <th>Type</th>
            <th>Runner</th>
            <th>Price</th>
            </thead>
            <tbody class="tableBody">
            <tr>
              <td class="tableCell">${{checkPartial(bet.stake)}}</td>
              <td class="tableCell">{{bet.win_plc}}</td>
              <td>{{bet.runnerNumber}}. {{bet.runnerName}}</td>
              <td class="tableCell">{{formatPrice(bet.odds)}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="lineBreak"></div>
        <div>
          <p v-if="bet.refund_owing" class="potentialReturn">
            <b>Balance Refunded:</b> {{formatPrice(bet.refund_owing)}}
          </p>
          <p v-if="!bet.refund_owing" class="potentialReturn">
            <b>Potential Return:</b> ${{calculatePotentialReturn(bet.odds, bet.stake, bet.refund_owing)}}
          </p>
          <p class="deductions">* Deductions may apply</p>
          <p class="timestamp" v-if="!bet.reprint">{{formatNowTime(Date.now())}}</p>
          <p class="timestamp" v-if="bet.reprint">REPRINTED: <br>{{formatNowTime(Date.now())}}</p>
          <p class="timestamp" v-if="bet.reprint">Version: <br>{{bet.reprint.version}}</p>
        </div>
        <h4>Terminal Loc: {{getTerminalLocation}}</h4>
        <p>{{bet.ticket_id}}</p>
        <div>
          <VueBarcode :value="stripTicketID(bet.ticket_id)" format="ITF" :text="bet.ticket_id"/>
          <h5>BetMakers Technology Group</h5>
        </div>
      </div>
      <!-- refund reciept -->
      <div v-if="bet.refund_owing" class="receiptContainer">
        <div class="logoContainer">
          <img :src="imageUrl" alt="venue logo"/>
          <p>{{bet.ticket_id}}</p>
        </div>
        <div class="tableContainer">
          <h3 class="raceHeader" v-if="bet.refund_owing">* TELLER COPY *</h3>
          <h3 class="raceHeader">{{bet.trackName}} - Race {{bet.trackNumber}}</h3>
          <h4 class="raceHeader">{{bet.raceName}}</h4>
          <h4 class="raceHeader">Start: {{formatStartTime(moment(bet.startTime))}}</h4>
          <div class="lineBreak"></div>
          <table class="tableContainer">
            <thead class="tableHeader">
            <th>Cost</th>
            <th>Type</th>
            <th>Runner</th>
            <th>Price</th>
            </thead>
            <tbody class="tableBody">
            <tr>
              <td class="tableCell">${{checkPartial(bet.stake)}}</td>
              <td class="tableCell">{{bet.win_plc}}</td>
              <td>{{bet.runnerNumber}}. {{bet.runnerName}}</td>
              <td class="tableCell">{{formatPrice(bet.odds)}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="lineBreak"></div>
        <div>
          <p v-if="bet.refund_owing" class="potentialReturn">
            <b>Balance Refunded:</b> {{formatPrice(bet.refund_owing)}}
          </p>
          <p v-if="!bet.refund_owing" class="potentialReturn">
            <b>Potential Return:</b> ${{calculatePotentialReturn(bet.odds, bet.stake, bet.refund_owing)}}
          </p>
          <p class="deductions">* Deductions may apply</p>
          <p class="timestamp" v-if="!bet.reprint">{{formatNowTime(Date.now())}}</p>
          <p class="timestamp" v-if="bet.reprint">REPRINTED: <br> {{formatNowTime(Date.now())}}</p>
        </div>
        <h4>Terminal Loc: {{getTerminalLocation}}</h4>
        <div>
          <VueBarcode v-if="bet.refund" :value="stripTicketID(bet.refund.ticket_id)" format="ITF" :text="bet.refund.ticket_id"/>
          <VueBarcode v-else :value="stripTicketID(bet.ticket_id)" format="ITF" :text="bet.ticket_id"/>
          <h5>BetMakers Technology Group</h5>
        </div>
      </div>
    </div>
<!-- Start Manual Transaction Ticket Teller -->
    <div v-if="Object.keys(transactionReceipt).length > 0">
      <div class="receiptContainer">
        <div class="logoContainer">
          <img :src="imageUrl" alt="venue logo"/>
        </div>
        <div class="tableContainer">
          <h3 class="raceHeader">* TELLER COPY *</h3>
          <h3 class="raceHeader">MANUAL TRANSACTION</h3>
          <div>
            <h4>Amount: ${{transactionReceipt.amount}}</h4>
            <h4>Type: {{ checkTransactionType(transactionReceipt.type) }}</h4>
            <h4>Terminal Loc: {{getTerminalLocation}}</h4>
            <h4>Username: {{userName}}</h4>
          </div>
          <div class="lineBreak"></div>
          <div class="mt-2">
            <h3>Date & Time</h3>
            <h4>{{formatTime(transactionReceipt.date)}}</h4>
          </div>
        </div>
      </div>
<!-- Start Manual Transaction Ticket Money Room -->
      <div class="receiptContainer">
        <div class="logoContainer">
          <img :src="imageUrl" alt="venue logo"/>
        </div>
        <div class="tableContainer">
          <h3 class="raceHeader">* MONEY ROOM COPY *</h3>
          <h3 class="raceHeader">MANUAL TRANSACTION</h3>
          <div>
            <h4>Amount: ${{transactionReceipt.amount}}</h4>
            <h4>Type: {{ checkTransactionType(transactionReceipt.type) }}</h4>
            <h4>Terminal Loc: {{getTerminalLocation}}</h4>
            <h4>Username: {{userName}}</h4>
          </div>
          <div class="lineBreak"></div>
          <div class="mt-2">
            <h3>Date & Time</h3>
            <h4>{{formatTime(transactionReceipt.date)}}</h4>
          </div>
        </div>
      </div>
    </div>
<!-- Start Cash Postion Ticket -->
    <div v-if="cashPosition">
      <div class="receiptContainer">
        <div class="logoContainer">
          <img :src="imageUrl" alt="venue logo"/>
        </div>
        <div class="tableContainerCashPos">
          <h3 class="raceHeader">CASH POSITION</h3>
          <table class="tableContainerCashPos">
            <tbody>
              <tr>
                <td>{{ calcSoldValue() }}</td>
                <td style="text-align: left">Tickets Sold</td>
                <td style="text-align: right">${{ calcSold() }}</td>
              </tr>
              <tr>
                <td>{{ calcPaidValue()}}</td>
                <td style="text-align: left">Tickets Cashed</td>
                <td style="text-align: right">${{ calcPaid() }}</td>
              </tr>
              <tr>
                <td></td>
                <td style="text-align: left">Draws</td>
                <td style="text-align: right">${{ calcDraws() }}</td>
              </tr>
              <tr>
                <td>{{calcReturnsValue()}}</td>
                <td style="text-align: left">Returns</td>
                <td style="text-align: right">${{ calcReturns() }}</td>
              </tr>
            </tbody>
          </table>
          <table style="border-top: 5px solid black" class="tableContainerCashPos">
            <tbody>
              <tr>
                <td colspan="3">CASH BALANCE</td>
                <td style="text-align: right">${{calcTotal()}}</td>
              </tr>
              <tr style="font-size: 12px">
                <td colspan="2">{{formatNowTime(Date.now())}}</td>
              </tr>
            </tbody>
          </table>
          <h5>Terminal Loc: {{getTerminalLocation}}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import VueBarcode from 'vue-barcode'
import {logo} from '../common/constants'
import moment from 'moment'

export default {
  name: "Receipts",
  props: {
    userName: String
  },
  components: {
    VueBarcode
  },
  methods: {
    moment,
    formatPrice(price) {
      return `$${parseFloat(price)?.toFixed(2)}`
    },
    calculatePotentialReturn(odds, stake, refund) {
      let newStake = 0
      if (refund) {
        newStake = parseFloat(stake) - refund
      } else {
        newStake = stake
      }
      const profit = odds * newStake
      // const potentialReturn = profit + parseFloat(newStake)
      return parseFloat(profit)?.toFixed(2)
    },
    stripTicketID(id) {
      return id?.replace(/-/g, '') || ''
    },
    formatTime(time) {
      const newTime = new Date(time)
      return moment(newTime, 'YYYY-MM-DD H:mm:ss').format('MMMM Do YYYY, h:mm:ss a');
    },
    formatStartTime(time) {
      return moment(time, 'YYYY-MM-DD H:mm:ss').format('LLL');
    },
    formatNowTime(time) {
      const newTime = new Date(time)
      return moment(newTime, 'YYYY-MM-DD H:mm:ss').format('MMMM Do YYYY, h:mm:ss a');
    },
    checkPartial(stake, refund) {
      let newStake = 0
      if (refund) {
        newStake = parseFloat(stake) - refund
      } else {
        newStake = stake
      }
      return parseFloat(newStake)
    },
    checkTransactionType(type) {
      switch (type) {
        case 2:
          return 'Draw'
        case 3:
          return 'Return'
      }
    },
    calcSold() {
      let filterTransactions = this.transactionHistory?.filter((item) => {
        return (item.reference === 'bet')
      })
      const total = filterTransactions.reduce((acc, item) => acc + parseFloat(item.amount), 0);
      return Number(total.toFixed(2)) || 0
    },
    calcSoldValue() {
      let filterTransactions = this.transactionHistory?.filter((item) => {
        return (item.reference === 'bet')
      })
      const data = filterTransactions?.length
      return data
    },
    calcPaid() {
      let filterTransactions = this.transactionHistory?.filter((item) => {
        return (item.type === 1)
      })
      const total = filterTransactions.reduce((acc, item) => acc + parseFloat(item.amount), 0);
      return Number(total.toFixed(2))  || 0
    },
    calcPaidValue() {
      let filterTransactions = this.transactionHistory?.filter((item) => {
        return (item.type === 1)
      })
      const data = filterTransactions?.length
      return data
    },
    calcDraws() {
      let filterTransactions = this.transactionHistory?.filter((item) => {
        return (item.type === 2 && item.amount < 0)
      })
      const total = filterTransactions.reduce((acc, item) => acc + parseFloat(item.amount), 0);
      return Number(total.toFixed(2))  || 0
    },
    calcReturns() {
      let filterTransactions = this.transactionHistory?.filter((item) => {
        return ((item.type === 2 || item.type === 3) && item.amount > 0)
      })
      const total = filterTransactions.reduce((acc, item) => acc + parseFloat(item.amount), 0);
      return Number(total.toFixed(2)) || 0
    },
    calcReturnsValue() {
      let filterTransactions = this.transactionHistory?.filter((item) => {
        return ((item.type === 2 || item.type === 3) && item.amount > 0)
      })
      const data = filterTransactions?.length
      return data
    },

    calcTotal() {
      const sold = this.calcSold()
      const paid = this.calcPaid()
      const draws = this.calcDraws()
      const returns = this.calcReturns()
      const total = (sold + draws + returns + paid)
      return total.toFixed(2)
    }
  },
  computed: {
    ...mapGetters(['getPrintedBets', 'getTerminalLocation']),
    ...mapState(['processingBets', 'printedBets', 'transactionReceipt', 'cashPosition', 'transactionHistory']),
    betsSent() {
      const bets = [...this.printedBets]
      return bets.length > 0 ? bets : null
    },
    betsCompleted() {
      return this.betsSent?.filter(bet => bet.status && bet.status !== 'pending')
    },
    imageUrl () {
      return logo[this.$route.query.venue]
    }
  }
}
</script>

<style>
@media print {
  * { overflow: visible !important; }
  @page { margin: 0; }
  header {
    display: none !important;
  }
  .navigationRow {
    display: none !important;
  }
  .navBarHeight {
    display: none !important;
  }
  .v-dialog__content {
    display: none !important;
  }
  .v-overlay__scrim {
    display: none !important;
  }
  .container--fluid {
    padding: 0 !important;
  }
  main {
    position: unset !important;
    width:100% !important;
    padding:0 !important;
    margin:0 !important;
  }
  .receiptContainer {
    font-family: "Arial Black";
    visibility: visible;
    page-break-after: always;
    text-align: center;
    width: 350px;
  }
  .raceHeader {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .tableHeader {
    font-size: 14px;
  }
  .tableBody {
    font-size: 12px;
  }
  .tableCell {
    white-space: nowrap;
  }
  .logoContainer {
    margin-top: 5px;
  }
  .logoSet {
    max-width: 250px;
    max-height: 80px;
    margin:0 auto;
    margin-top:10px;
  }
  .lineBreak {
    margin:0 auto;
    height:5px;
    width:100%;
    border-bottom:3px solid #000;
  }
  .potentialReturn {
    margin-top: 8px;
    margin-bottom: 0 !important;
    font-size: 18px;
  }
  .deductions {
    font-size: 14px;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .timestamp {
    font-size: 16px;
    margin-top: 0 !important;
    margin-bottom: 0px !important;
  }
  .receiptFooter {
    margin-top: 5px;
    margin-bottom: 5px;
    font-size: 15px;
    font-weight: 700;
  }
  .tableContainer {
    display: table;
    width: 90%;
    margin:0 auto;
    border-collapse: collapse;
  }
  .tableContainer tr td {
    /*border: 3px solid black;*/
  }
  .tableContainerCashPos {
    display: table;
    width: 90%;
    margin:0 auto;
    border-collapse: collapse;
  }
  .tableContainerCashPos tr td {
    /* border: 3px solid black; */
  }
  th {
    /*border: 3px solid black*/
  }
  .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
  }
}
@media screen {
  .receiptContainer {
    display: none;
    background-color: white;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 400px;
  }
}
</style>
